import React, { Component } from 'react';
import './AdminUI.css';
import ProfileView from './ProfileView';
import MyBookings from './MyBookings';
import Notification from './Notification';
import ChatDashboard from './ChatDashboard';
import PaymentHistory from './PaymentHistory';

class AccountDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 'profile' // Default active tab
    };
  }

  handleMenuClick = (tabName) => {
    this.setState({ activeTab: tabName });
  };

  handleLogout = () => {
    alert('Logging out...');
    // Add your logout logic here
  };

  renderActiveComponent = () => {
    switch (this.state.activeTab) {
      case 'profile':
        return <ProfileView />;
      case 'booking':
        return <MyBookings />;
      case 'paymenthistory':
        return <PaymentHistory />;
      case 'notifications':
        return <Notification />;
      default:
        return <ProfileView />;
    }
  };

  render() {
    const { activeTab } = this.state;

    return (
      <div className="admin-wrapper">
        
        <aside className="desktop-sidebar">
          <div>
            <div className="sidebar-user">
              <div className="avatar-circle">M</div>
              <div>
                <div style={{ fontWeight: '600', fontSize: '15px' }}>Md Kowsar Mahmud</div>
                <div style={{ fontSize: '12px', color: 'var(--text-muted)' }}>Manage account</div>
              </div>
            </div>

            <ul className="menu-list">
              <li 
                className={`menu-item ${activeTab === 'profile' ? 'active' : ''}`}
                onClick={() => this.handleMenuClick('profile')}
              >
                👤 Profile
              </li>
              <li 
                className={`menu-item ${activeTab === 'booking' ? 'active' : ''}`}
                onClick={() => this.handleMenuClick('booking')}
              >
                📅 Bookings
              </li>
              <li 
                className={`menu-item ${activeTab === 'paymenthistory' ? 'active' : ''}`}
                onClick={() => this.handleMenuClick('paymenthistory')}
              >
                💬 Payment
              </li>
              <li 
                className={`menu-item ${activeTab === 'notifications' ? 'active' : ''}`}
                onClick={() => this.handleMenuClick('notifications')}
              >
                🔔 Notifications
              </li>
            </ul>
          </div>

          <div 
            className="menu-item" 
            style={{ color: '#EF4444', borderTop: '1px solid var(--border)', paddingTop: '16px' }}
            onClick={this.handleLogout}
          >
            ↪ Logout
          </div>
        </aside>

        {/* Main View Area - Fully responsive on Mobile & Desktop */}
        <main className="main-content">
          {this.renderActiveComponent()}
        </main>
      </div>
    );
  }
}

export default AccountDashboard;